/**
 * Rider API (공유 레이어)
 * riderStatus와 notice 등 여러 feature에서 공통으로 사용하는 라이더 API
 */
import { apiClient } from '@/shared/api/client';

export type RiderApiItem = {
    riderId?: string;
    name?: string;
    phoneNumber?: string;
    deliveryStatus?: string;
    deliveryStatusName?: string;
    insDate?: string;
    deliveryMeth?: string;
    deliveryMethName?: string;
    registNum?: string;
    status?: {
        code?: string;
        description?: string;
        contractStatusCode?: string;
        contractStatusName?: string;
        deliveryStatusCode?: string;
    };
    contStatus?: string;
    contractStatusName?: string;
    suppId?: string;
    centerName?: string;
    suppName?: string;
    insurCode?: string;
    insurCodeName?: string;
    insurStatusCd?: string;
    insurStatusCodeName?: string;
    preAcctYn?: string;
    acctApplyDay?: string;
    acctApplyType?: string;
    acctApplyTypeName?: string;
    nextAcctApplyDay?: string;
    nextAcctApplyType?: string;
    nextAcctApplyTypeName?: string;
    accountNum?: string;
    bankCode?: string;
    accName?: string;
    riderType?: string;
    riderTypeName?: string;
    typeCode?: string;
    typeName?: string;
    birthDate?: string;
    insUser?: string;
    pwNum?: string;
    updDate?: string;
    updUser?: string;
    riderInsDate?: string;
    contEdDate?: string;
    balAmt?: number;
    vpayRegistYn?: string;
};

export type RiderFilter = {
    riderName?: string;
    riderId?: string;
    phoneNum?: string;
    centerId?: string;
    contStatus?: string;
};

export type RiderSearchResponseItem = {
    centerId?: string;
    id?: string;
    center_id?: string;
    name?: string;
    centerName?: string;
    statusCode?: string;
    status?: {
        code?: string;
        desc?: string;
    };
    statusDesc?: string;
    statusDescription?: string;
};

export type SupplierApiItem = {
    centerId?: string;
    suppId?: string;
    id?: string;
    name?: string;
    suppName?: string;
    centerName?: string;
};

export type SupplierListApiResponse =
    | RiderSearchResponseItem[]
    | { suppliers: RiderSearchResponseItem[] }
    | { data: RiderSearchResponseItem[] };

const BASE_PATH = '/api/v1/rider';

export const riderApi = {
    getRiderList: async (filters: RiderFilter = {}): Promise<RiderApiItem[]> => {
        const response = await apiClient.get<RiderApiItem[]>(`${BASE_PATH}/status`, { params: filters });
        return response.data;
    },

    getSuppliers: async (): Promise<SupplierListApiResponse> => {
        const response = await apiClient.get<SupplierListApiResponse>(`${BASE_PATH}/suppliers`);
        return response.data;
    },
};
